<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-6">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> Mijn accountgegevens</strong>
                        <small>
                            <span v-if="isEditing">wijzigen</span>
                            <span v-else>toevoegen</span>
                        </small>
                    </div>
                    <form @submit.prevent="saveItem" autocomplete="off">
                        <input autocomplete="off" name="hidden" type="text" style="display:none;">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="voornaam">Voornaam <sup>*</sup></label>
                                <input type="text" v-model="model.voornaam" id="voornaam" name="voornaam" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('voornaam') }" />
                                <span class="small text-danger" v-show="errors.has('voornaam')">Voornaam is verplicht</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="naam">Naam <sup>*</sup></label>
                                <input type="text" v-model="model.naam" id="naam" name="naam" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('naam') }" />
                                <span class="small text-danger" v-show="errors.has('naam')">Naam is verplicht</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="email">E-mail <sup>*</sup></label>
                                <input type="text" @keyup="checkemail" v-model="model.email" id="email" name="email" v-validate="'required|email'" :class="{'form-control': true, 'is-invalid': (errors.has('email') || isErrorEmail) }" />
                                <span class="small text-danger" v-show="errors.has('email')">Ongeldig e-mailadres</span>
                                <span class="small text-danger" v-show="(isErrorEmail && !errors.has('email'))">E-mailadres bestaat reeds</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="tel">Telefoonnummer</label>
                                <input type="text" v-model="model.tel" id="tel" name="tel" class="form-control" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="password">Wachtwoord <i>(alleen invullen om te wijzigen)</i></label>
                                <input type="text" v-model="model.password" id="password" name="password" v-validate="''" :class="{'form-control': true, 'is-invalid': errors.has('password') }" />
                                <span class="small text-danger" v-show="errors.has('password')">Ongeldig e-mailadres</span>
                            </div>
                        </div>
                    </div>
                    <div slot="footer">
                        <b-button type="submit" variant="primary">
                            <span>Opslaan</span>
                        </b-button>
                    </div>
                    </form>
                </b-card>
            </div>
        </div>
        <div style="height: 17em"></div>
    </div>
</template>

<script>
    import api from '../../api/account';

    export default {
        name: 'Form',
        props: ['model', 'typeusers', 'bedrijven', 'isEditing'],
        data () {
            return {
                isError: false,
                isErrorEmail: false,
            };
        },
        methods: {
            validEmail(mail)
            {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
                {
                    return true;
                }
                return false;
            },
            checkemail () {
                if (this.validEmail(this.model.email)) {
                    api.isValidEmail(this.model.id, this.model.email).then((response) => {
                        this.isErrorEmail = (response.data === 'false');
                    });
                }
            },
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('save-item', this.model);
                    }
                });
            },
        },
        components: {
        },
    };
</script>

<style>

    input, select {
        padding: .55em .5em;
        font-size: 100%;
        border: 1px solid #ccc;
        width: 100%
    }

    .unstyled::-webkit-outer-spin-button, /* Removes arrows */
    .unstyled::-webkit-inner-spin-button, /* Removes arrows */
    .unstyled::-webkit-clear-button { /* Removes blue cross */
      -webkit-appearance: none;
      margin: 0;
    }

</style>



// WEBPACK FOOTER //
// src/pages/account/FormMijnAccount.vue